(function ($) {
  $(function () {
    var $bannerSecondLevel = $('.banner-second-level');
    if ($bannerSecondLevel.length) {
      $(this).find('.slider-wrapper').slick({
        infinite: true,
        swipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        fade: true,
        slidesToSwipe: 1,
        arrows: false,
        adaptiveHeight: true,
        dots: true,
      });

      setTimeout(()=>{
        console.log('ran')
        let watch_button = document.querySelector('.banner-hero .banner-content .section-heading .video-play')
        let anim_click = document.querySelector('.banner-hero .banner-content .animation-has-video g.video-play')

        if (watch_button) {
          watch_button.addEventListener('click',(e)=>{
            e.preventDefault();
            console.log('watch');   
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1357156334961344');
            fbq('track', 'ButtonClick');     
          })
        }

        if (anim_click) {
          anim_click.addEventListener('click',(e)=>{
            e.preventDefault();
            console.log('watch 2');   
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1357156334961344');
            fbq('track', 'ButtonClick');     
          })
        }
      },1000)



    }
  });
})(jQuery);

let bannerHero = document.querySelector('.banner-hero')

if(bannerHero){
    (()=>{
      let watchButton = document.querySelector('.banner-hero .banner-content .section-heading .video-play')

      if (watchButton) {
        watchButton.addEventListener('click',(e)=>{
          e.preventDefault();
          window.lintrk('track', { conversion_id: 15800876 });
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1357156334961344');
          fbq('track', 'ButtonClick');     
        })
      }

      setTimeout(()=>{
        let videoClick = document.querySelector('.banner-hero .video-with-lottie-wrap .video-container .video-play')

        if (videoClick) {
          videoClick.addEventListener('click',(e)=>{
            e.preventDefault();
            window.lintrk('track', { conversion_id: 15800876 });
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1357156334961344');
            fbq('track', 'ButtonClick');     
          })        
        }
      },2000)

    })();
}
